import * as React from 'react';

export default props => (
    <svg
        viewBox='0 0 24 24'
        {...props}
    >
        <g
            fill='none'
            fillRule='evenodd'
            opacity='.74'
        >
            <path
                d='M0 0h24v24H0z'
            />
            <path
                fill='#000'
                d='M20.59 2.25H3.41c-1.05 0-1.91.877-1.91 1.95v11.7c0 1.072.86 1.95 1.91 1.95h6.68v1.95H8.183v1.95h7.636V19.8H13.91v-1.95h6.682c1.05 0 1.909-.878 1.909-1.95V4.2c0-1.073-.86-1.95-1.91-1.95zm-.34 13.5H3.75V4.5h16.5v11.25z'
            />
        </g>
    </svg>
)
